import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ian-card',
  templateUrl: './ian-card.component.html',
  styleUrls: ['./ian-card.component.scss'],
})
export class IanCardComponent implements OnInit {
  /** Mostrar o no toolbar de formulario */
  @Input() showHeader = true;

  /** Enviar en falso para que la card no se eleve */
  @Input() contentElevation = true;

  /** Enviar en falso para remover paddings/margins */
  @Input() margins = true;

  /** Muestro panel a izquierda de template */
  @Input() showDrawer = false;

  ngOnInit(): void {}
}
